'use client';

import type { EmblaCarouselType } from 'embla-carousel';
import type { RefObject } from 'react';
import { useCarouselContext } from '@eliadmin/core/src/components/ui/carousel-context';
import { useCarouselAutoplay } from '../ui/use-carousel-autoplay';
import { advanceProductCarousel } from '../../utils/product-carousel-autoplay';

const advance = (api: EmblaCarouselType) => {
  advanceProductCarousel(api, window.innerWidth);
};

export function ProductCarouselAutoplay({ containerRef }: {
  containerRef: RefObject<HTMLElement | null>;
}) {
  const context = useCarouselContext();
  useCarouselAutoplay(context?.api, { interactionRootRef: containerRef, advance });
  return null;
}
